import { Component, ViewChild } from '@angular/core';
import { Item } from './../../../../shared/dropdown/dropdown.models';
import { ClientMaster, Market, SubMarket, Client, ReportSource } from '../../../models/client-master.model';
import { ClientMasterBehaviorService } from '../../../services/client-master-behavior.service';
import { DropdownComponent } from 'src/app/modules/shared/dropdown/dropdown.component';
import { v4 } from 'uuid';
import * as _ from 'lodash';
import { GlobalStoreService } from '../../../services/global-store.service';

@Component({
    selector: 'app-report-filter',
    standalone: false,
    templateUrl: './report-filter.component.html',
    styleUrls: ['./report-filter.component.scss']
})
export class ReportFilterComponent{

    markets: Item[] = [];
    subMarkets: Item[] = [];
    clients: Item[] = [];
    months: Item[] = [];
    reportSource: Item[] = [];
    reportSource2: Item[] = [];
    reports: ReportSource[] = [{ Id: 2, Name: 'Drive Engineer Plan' },{ Id: 1, Name: 'Drive Update Plan' } ];
    reports2: ReportSource[] = [ { Id: 2, Name: 'Drive Engineer Plan' }];
    reportChange:string;

    @ViewChild('subMarket') subMarketDropDown: DropdownComponent;
    @ViewChild('client') clientDropDown: DropdownComponent;

    filterBy = (i: Item) => i.id !== 0 && i.visible && i.checked;

    constructor(
        public globalStore: GlobalStoreService,
        public clientMasterBehavior: ClientMasterBehaviorService) {
        const clientMaster = this.globalStore.clientMaster;

        const newValue = JSON.parse(localStorage.getItem('clientMaster'));

        // to get 24 months data
        const minMonth = new Date().getMonth() + 1;
        const year = new Date().getFullYear() - 1;
        const monthsValue = Array.from({ length: 24 }, (a, i) => new Date(year, minMonth + i));


        /* istanbul ignore else*/
        if (clientMaster.Markets.length) {
            this.markets = [
                {
                    uuid: v4(),
                    id: 0,
                    marketId: 0,
                    subMarketId: 0,
                    name: 'All',
                    checked: true,
                    visible: true
                }
            ];
            this.subMarkets = [
                {
                    uuid: v4(),
                    id: 0,
                    marketId: 0,
                    subMarketId: 0,
                    name: 'All',
                    checked: true,
                    visible: true
                }
            ];
            this.clients = [
                {
                    uuid: v4(),
                    id: 0,
                    marketId: 0,
                    subMarketId: 0,
                    name: 'All',
                    checked: true,
                    visible: true
                }
            ];
            //  this.reportSource = [
            //       {
            //          uuid: v4(),
            //          id: 0,
            //          name: 'All',
            //         checked: false,
            //          visible: true
            //      }
            //   ];
        }

        this.markets = [
            ...this.markets,
            ...clientMaster.Markets.map(market => ({
                uuid: v4(),
                id: market.MarketId,
                name: market.MarketName,
                marketId: 0,
                subMarketId: 0,
                checked: true,
                visible: true
            } as Item))];

        this.subMarkets = [
            ...this.subMarkets,
            ...clientMaster.SubMarkets.map(subMarket => ({
                uuid: v4(),
                id: subMarket.SubMarketId,
                name: subMarket.SubMarketName,
                marketId: subMarket.MarketId,
                subMarketId: 0,
                checked: true,
                visible: true
            } as Item))];

        this.clients = [
            ...this.clients,
            ...(
                _.chain(clientMaster.Clients)
                    .map((subMarket, index) => ({
                        uuid: v4(),
                        id: subMarket.ClientId,
                        name: subMarket.ClientName,
                        marketId: subMarket.MarketId,
                        subMarketId: subMarket.SubMarketId,
                        revenueOrder: index,
                        checked: true,
                        visible: true
                    } as Item))
                    .orderBy([i => i.name.toLowerCase()], 'asc')
                    .value()
            )

        ];

        this.months = monthsValue.map((k, i) => ({
            uuid: v4(),
            checked: this.setCheckedMonths(k),
            id: i + 1,
            visible: true,
            name: this.getMonthAndYear(k)
        }));

        this.reportSource = [
            ...this.reportSource,
           
            ...this.reports.map(r => ({
                uuid: v4(),
                checked: this.setDefault(r.Id),
                id: r.Id,
                visible: true,
                name: r.Name
            }))
            
        ];
        this.reportSource2 = [
            ...this.reportSource2,
           
            ...this.reports2.map(r => ({
                uuid: v4(),
                checked: true,
                id: r.Id,
                visible: true,
                name: r.Name
            }))
            
        ];
        this.globalStore.reportSource=this.reportSource;

        if (newValue && newValue.Markets.length) {
            this.markets = newValue.Markets;
            this.subMarkets = newValue.SubMarkets;
            this.clients = newValue.Clients;
            localStorage.removeItem('clientMaster');
        }

        this.onSearchClick();
    }
    

    getMonthAndYear(date: Date) {
        const [a, month, b, year] = date.toDateString().split(' ');
        return `${month} ${year.slice(2, 4)}`;
    }

    setCheckedMonths(date: Date) {
        const currentMonth = new Date().getMonth();
        const currentYear = new Date().getFullYear();
        
        let financialYear:number[];
        if(currentMonth>=4){
            financialYear=[currentYear,currentYear+1]
        }else{
            financialYear=[currentYear-1,currentYear] 
        }
        let months:Date[]=Array.from({ length: 12 }, (a, i) => new Date(financialYear[0],3+i));
       // let checked:boolean;
        return ((months.find(x => x.getMonth()==date.getMonth()&& x.getFullYear()==date.getFullYear()) ))?true:false;
       // return date.getMonth() === currentMonth && date.getFullYear() === currentYear ? true : false;
    }
    setDefault(id: number) {
        return id === this.reports[0].Id ? true : false;
    }
    get allSubMarket() {
        return this.subMarkets.find(i => i.id === 0);
    }

    get allClient() {
        return this.clients.find(i => i.id === 0);
    }

    get isFilterEmpty() {
        return this.markets.filter(this.filterBy).length === 0 ||
            this.subMarkets.filter(this.filterBy).length === 0 ||
            this.clients.filter(this.filterBy).length === 0 ||
            this.months.filter(this.filterBy).length === 0 ||
            this.reportSource.filter(this.filterBy).length === 0;
    }

    everyItemState(items: Item[], checked: boolean) {
        return items.filter(i => i.visible && i.id !== 0).every(i => i.checked === checked);
    }

    isEmpty(items: Item[]) {
        return items.filter(i => i.visible && i.id !== 0).length === 0;
    }

    marketChange($event: any) {
        const checked = $event.$event.target.checked;
        const current = $event.item as Item;

        if (current.id === 0) {
            this.subMarkets.forEach(subMarket => {
                subMarket.checked = checked;
                subMarket.visible = checked;
            });
            this.clients.forEach(client => {
                client.checked = checked;
                client.visible = checked;
            });
        } else {
            const index = this.markets.findIndex(i => i.id === current.id);
            this.markets[index].checked = checked;

            this.markets.forEach(market => {
                this.subMarkets.forEach(subMarket => {
                    if (subMarket.marketId === market.id) {
                        subMarket.checked = market.checked;
                        subMarket.visible = market.checked;
                    }
                });
                this.clients.forEach(client => {
                    if (client.marketId === market.id) {
                        client.checked = market.checked;
                        client.visible = market.checked;
                    }
                });
            });

            const isEveryMarketsUnchecked = this.everyItemState(this.markets, false);
            const isEverySubMarketsChecked = this.everyItemState(this.subMarkets, true);

            this.allSubMarket.checked = isEverySubMarketsChecked;
            this.allSubMarket.visible = true;

            if (isEveryMarketsUnchecked) {
                this.allSubMarket.visible = false;
                this.allSubMarket.checked = false;
            }

            const isEverySubMarketsUnchecked = this.everyItemState(this.subMarkets, false);
            const isEveryClientChecked = this.everyItemState(this.clients, true);

            this.allClient.checked = isEveryClientChecked;
            this.allClient.visible = true;

            if (isEverySubMarketsUnchecked) {
                this.allClient.visible = false;
                this.allClient.checked = false;
            }
        }

        if (this.isEmpty(this.subMarkets)) {
            this.allClient.checked = false;
            this.allClient.visible = false;
        }
        if (this.isEmpty(this.clients)) {
            this.allClient.checked = false;
            this.allClient.visible = false;
        }

        this.subMarketDropDown.search = '';
        this.clientDropDown.search = '';
    }

    subMarketChange($event: any) {
        const checked = $event.$event.target.checked;
        const current = $event.item as Item;

        if (current.id === 0) {
            this.subMarkets.filter(i => i.visible).forEach(subMarket => {
                this.clients.forEach(client => {
                    if (client.subMarketId === subMarket.id) {
                        client.checked = subMarket.checked;
                        client.visible = subMarket.checked;
                    }
                });
            });
        } else {

            const index = this.subMarkets.findIndex(i => i.id === current.id);
            this.subMarkets[index].checked = checked;

            this.subMarkets.filter(i => i.visible).forEach(subMarket => {
                this.clients.forEach(client => {
                    if (client.subMarketId === subMarket.id) {
                        client.checked = subMarket.checked;
                        client.visible = subMarket.checked;
                    }
                });
            });

            const isEverySubMarketsChecked = this.everyItemState(this.subMarkets, true);
            const isEverySubMarketsUnchecked = this.everyItemState(this.subMarkets, false);
            const isEveryClientChecked = this.everyItemState(this.clients, true);

            this.allClient.checked = isEveryClientChecked;
            this.allClient.visible = true;

            if (isEverySubMarketsChecked) {
                this.allSubMarket.visible = true;
                this.allSubMarket.checked = true;
            }
            if (isEverySubMarketsUnchecked) {
                this.allClient.visible = false;
                this.allClient.checked = false;
            }
        }

        if (this.isEmpty(this.clients)) {
            this.allClient.checked = false;
            this.allClient.visible = false;
        }

        this.clientDropDown.search = '';
    }
    reportSourceChange(name:string){
        this.reportChange=name;
        this.globalStore.reportSource.forEach(x=> {
            if(x.name === name) {
            x.checked = true;
            }
            else {
            x.checked = false;
            }
        });
    }
    onSearchClick() {
        const clientMaster: ClientMaster = {
            Markets: [],
            SubMarkets: [],
            Clients: [],
            visibleClients: [],
            Months: [],
            ReportSource: []
        };
        const filterBy = (i: Item) => i.id !== 0 && i.visible && i.checked;
        const filterByVisible = (i: Item) => i.id !== 0 && i.visible;
        clientMaster.Markets = this.markets.filter(filterBy).map(i => ({
            MarketId: i.id,
            MarketName: i.name
        } as Market));
        clientMaster.SubMarkets = this.subMarkets.filter(filterBy).map(i => ({
            SubMarketId: i.id,
            SubMarketName: i.name,
            MarketId: i.marketId
        } as SubMarket));
        clientMaster.Clients = _.chain(this.clients)
            .filter(filterBy)
            .orderBy([i => i.revenueOrder], 'asc')
            .map(i => ({
                ClientId: i.id,
                ClientName: i.name,
                MarketId: i.marketId,
                SubMarketId: i.subMarketId
            } as Client))
            .value();
        clientMaster.visibleClients = _.chain(this.clients)
            .filter(filterByVisible)
            .orderBy([i => i.revenueOrder], 'asc')
            .map(i => ({
                ClientId: i.id,
                ClientName: i.name,
                MarketId: i.marketId,
                SubMarketId: i.subMarketId
            } as Client))
            .value();
        clientMaster.Months = this.months.filter(filterBy).map(k => k.name);
        clientMaster.ReportSource = this.globalStore.reportSource.filter(filterBy).map(k => ({ Id: k.id, Name: k.name })) as ReportSource[];
        clientMaster.AllMonths = this.months.map(k => k.name);
        clientMaster.isAllClientSelected = this.clients.filter(({visible}) => visible).every(c => c.checked);
        clientMaster.isAllSubMarketSelected = this.subMarkets.filter(({visible}) => visible).every(c => c.checked);

        this.clientMasterBehavior.setClientMaster(clientMaster);
        this.globalStore.selectedReportSource=this.reportChange;
    }

    get getClientVisibility() {
        return this.globalStore.selectedReport === 7||this.globalStore.selectedReport === 11 || this.globalStore.selectedReport === 3 || this.globalStore.selectedReport === 10 || this.globalStore.selectedReport === 12 ? true : false;
    }
   

    get getReportSourceVisibility() {
        return (this.globalStore.selectedReport === 7||this.globalStore.selectedReport === 11||this.globalStore.selectedReport === 1 || this.globalStore.selectedReport === 3 || this.globalStore.selectedReport === 8 || this.globalStore.selectedReport === 9 || this.globalStore.selectedReport === 10 || this.globalStore.selectedReport === 12) ? true : false;
    }
    get getReportSource2Visibility() {
        return (this.globalStore.selectedReport === 7||this.globalStore.selectedReport === 11 ||this.globalStore.selectedReport === 2|| this.globalStore.selectedReport === 3 || this.globalStore.selectedReport === 8 || this.globalStore.selectedReport === 9 || this.globalStore.selectedReport === 10 || this.globalStore.selectedReport === 12) ? true : false;
    }
    

    get getMonthsVisibility() {
        return (this.globalStore.selectedReport === 2||this.globalStore.selectedReport === 11 || this.globalStore.selectedReport === 3 ||
            this.globalStore.selectedReport === 7 || this.globalStore.selectedReport === 8 || this.globalStore.selectedReport === 9 || this.globalStore.selectedReport === 10 || this.globalStore.selectedReport === 12) ? true : false;
    }

}
